import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=e09a277a&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e09a277a')) {
      api.createRecord('e09a277a', component.options)
    } else {
      api.reload('e09a277a', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=e09a277a&", function () {
      api.rerender('e09a277a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jMOguKsNkmF9/JS/comp/RatingDisplay.vue"
export default component.exports